import * as Mui from "@mui/material";
import { useMemo } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import SectionHeader from "../../../../../util/component/SectionHeader";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import Damages from "./Damages";
import GeneralInfoStep from "./GeneralInfoStep";
import RentalAgreementStep from "./RentalAgreementStep";

interface Props {}
const CreationDamageForm = (props:Props) => {
    const t = useOperationTranslation();

    const navigate = useNavigate();
    const location = useLocation();

    const steps = useMemo(() => [
        {
            label: t("damageForm.damageFormCreation.generalInfo.title"),
            path: "/operation/damages/forms/creation/general-info",
            order: 0,
        },
        {
            label: t("damageForm.damageFormCreation.rentalAgreement.title"),
            path: "/operation/damages/forms/creation/rental-agreement",
            order: 1,
        },
        {
            label: t("damageForm.damageFormCreation.damages.title"),
            path: "/operation/damages/forms/creation/damages",
            order: 2,
        }
      ], []);
    const activeStep = useMemo(() => {
        return steps.find((step) => step.path === location.pathname)?.order
    }, [location]);

    // const handleNext = (stepCount: number, path: string) => {
    //     navigate(path);
    // };

    return( 
        <>
            <SectionHeader 
                title = {t("damageForm.damageFormCreation.titleFirst") + " " + t("damageForm.damageFormCreation.titleSecond") + " " + t("damageForm.damageFormCreation.titleThird")}
                subtitle= {t("damageForm.damageFormCreation.subtitle")}
            />

            <Mui.Box ml={2} mr={2} mt={2} mb={2}>
                <Mui.Stepper activeStep={activeStep}>
                    {steps.map((step) => (
                        <Mui.Step key={`step_${step.label}`} sx={{ width: "50%" }}>
                            <Mui.StepLabel>{step.label}</Mui.StepLabel>
                        </Mui.Step>
                    ))}
                </Mui.Stepper>
            </Mui.Box>

            <Mui.Box ml={2} mr={2}>
                <Routes>
                    <Route path="/general-info" element={<GeneralInfoStep />} />
                    <Route path="/rental-agreement" element={<RentalAgreementStep />} />
                    <Route path="/damages" element={<Damages/>} />
                    <Route
                        path="*"
                        element={<Navigate to="/operation/damages/forms/creation/general-info" replace />}
                    />
                </Routes>
            </Mui.Box>
        </>
    )
}
export default CreationDamageForm;